<template>
  <div>
    <CommonHeader :page="'Historique caisse'" />

    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <CaisseTable title="Historique caisse"></CaisseTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CaisseTable from "./Tables/CaisseTable";
import CommonHeader from "@/components/CommonHeader";
export default {
  name: "tables",
  components: {
    CaisseTable,
    CommonHeader,
  },
};
</script>
<style></style>
